if (!customElements.get('lxj-plate-order-list')) {
  customElements.define('lxj-plate-order-list', class extends HTMLElement {
    connectedCallback() {
      if (!this.querySelector('form')) return;
      if (this.initialized) {
        this.setViewport.addEventListener('change', this.syncSets);
        this.syncSets();
        return;
      }
      this.initialized = true;
      this.form = this.querySelector('form');
      this.fields = this.querySelector('fieldset');
      this.inputs = [...this.querySelectorAll('input[data-variant]')];
      this.submit = this.querySelector('[type="submit"]');
      this.status = this.querySelector('[role="status"]');
      this.cartLink = this.querySelector('.lxj-order__cart');
      this.addText = this.submit.textContent;
      this.money = new Intl.NumberFormat(this.dataset.locale || 'en-US', {
        style: 'currency', currency: this.dataset.currency || 'USD'
      });
      this.setRows = [...this.querySelectorAll('details[data-set]')];
      this.setViewport = window.matchMedia('(max-width: 767px)');
      this.syncSets = () => {
        this.setRows.forEach(row => {
          const input = row.querySelector('input');
          if (!input.validity.valid) row.dataset.mobileOpen = 'true';
          const open = !this.setViewport.matches || row.dataset.mobileOpen === 'true';
          if (!open && row.querySelector('.lxj-order__set-body').contains(document.activeElement)) row.querySelector('summary').focus();
          row.open = open;
        });
      };
      this.setRows.forEach(row => row.querySelector('summary').addEventListener('click', event => {
        const input = row.querySelector('input');
        if (row.open && !input.validity.valid) {
          event.preventDefault();
          input.reportValidity();
          input.focus();
          return;
        }
        if (this.setViewport.matches) row.dataset.mobileOpen = String(!row.open);
      }));
      this.syncSets();
      this.setViewport.addEventListener('change', this.syncSets);
      this.fields.disabled = false;
      this.addEventListener('click', event => {
        const button = event.target.closest('[data-adjust]');
        if (!button || !this.contains(button) || button.disabled || this.pending) return;
        const input = button.parentElement.querySelector('input');
        const current = Number(input.value) || 0;
        const minimum = Number(input.dataset.min);
        const increment = Number(input.dataset.increment);
        const maximum = Number(input.max);
        const next = Number(button.dataset.adjust) > 0
          ? current <= 0 ? minimum : minimum + (Math.floor((current - minimum) / increment) + 1) * increment
          : current <= minimum ? 0 : minimum + (Math.ceil((current - minimum) / increment) - 1) * increment;
        const highest = minimum + Math.floor((maximum - minimum) / increment) * increment;
        input.value = String(Math.min(highest, Math.max(0, next)));
        this.update();
      });
      this.addEventListener('input', () => this.update());
      this.form.addEventListener('submit', event => {
        event.preventDefault();
        this.addItems();
      });
      this.update();
    }
    disconnectedCallback() {
      this.setViewport?.removeEventListener('change', this.syncSets);
    }
    update() {
      let total = 0;
      let valid = true;
      let count = 0;
      this.inputs.forEach(input => {
        const value = Number(input.value);
        const minimum = Number(input.dataset.min);
        const increment = Number(input.dataset.increment);
        const maximum = Number(input.max);
        const good = !input.validity.badInput && Number.isSafeInteger(value) && value >= 0 && value <= maximum
          && (value === 0 || (value >= minimum && (value - minimum) % increment === 0));
        input.setCustomValidity(good ? '' : this.dataset.invalid);
        valid = valid && good;
        if (good && !input.disabled) {
          total += value * Number(input.closest('[data-price]').dataset.price);
          count += value;
        }
        const group = input.parentElement;
        const unavailable = input.disabled;
        group.querySelector('[data-adjust="-1"]').disabled = unavailable || value <= 0 || this.pending;
        group.querySelector('[data-adjust="1"]').disabled = unavailable || value + (value === 0 ? minimum : increment) > maximum || this.pending;
        const set = input.closest('[data-set]');
        if (set) {
          set.querySelector('.lxj-order__selected').hidden = !good || value <= 0;
          set.querySelector('[data-selected-quantity]').textContent = String(value);
        }
      });
      this.querySelector('output').textContent = this.money.format(total / 100);
      this.submit.disabled = !valid || !count || this.pending || this.locked;
      if (!this.locked && !this.pending) this.status.textContent = valid ? '' : this.dataset.invalid;
      return valid && count > 0;
    }
    async addItems() {
      if (this.pending || this.locked || !this.update()) return;
      const items = this.inputs.filter(input => !input.disabled && Number(input.value) > 0)
        .map(input => ({ id: Number(input.dataset.variant), quantity: Number(input.value) }));
      this.pending = true;
      this.form.setAttribute('aria-busy', 'true');
      this.status.textContent = this.dataset.pending;
      this.status.tabIndex = -1;
      this.status.focus();
      this.submit.textContent = this.dataset.pending;
      this.update();
      this.fields.disabled = true;
      const controller = new AbortController();
      const timer = setTimeout(() => controller.abort(), 15000);
      try {
        const response = await fetch(this.form.action + '.js', {
          method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ items }), signal: controller.signal
        });
        const data = await response.json();
        if (!response.ok) {
          this.fail(typeof data.description === 'string' ? data.description : this.dataset.error);
          return;
        }
        this.inputs.forEach(input => { input.value = '0'; });
        this.status.textContent = '';
        this.locked = false;
        window.location.assign(this.form.dataset.cartUrl);
      } catch {
        this.fail(this.dataset.error);
      } finally {
        clearTimeout(timer);
        this.pending = false;
        this.fields.disabled = false;
        this.form.removeAttribute('aria-busy');
        this.submit.textContent = this.addText;
        this.update();
      }
    }
    fail(message) {
      this.locked = true;
      this.status.textContent = message === this.dataset.error ? message : message + ' ' + this.dataset.error;
      this.cartLink.hidden = false;
      this.cartLink.focus();
    }
  });
}
